import { getFirestore, doc } from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";

export const db        = getFirestore();
export const functions = getFunctions();

export const approvePost         = httpsCallable(functions, "approveBlogPost");
export const regeneratePost      = httpsCallable(functions, "regenerateBlogPost");
export const deletePost          = httpsCallable(functions, "deletePendingBlogPost");
export const deleteApprovedPost  = httpsCallable(functions, "deleteBlogPost");
export const editImageFn         = httpsCallable(functions, "editBlogImage");
export const regenImageFn        = httpsCallable(functions, "regenerateBlogImage");
export const createPost          = httpsCallable(functions, "createBlogPost");

export function pendingRef(docId) {
  return doc(db, "blog_posts_pending", docId);
}

export function taskRef(taskId) {
  return doc(db, "blog_tasks", taskId);
}

export function formatDate(iso) {
  try {
    return new Date(iso + "T00:00:00Z").toLocaleDateString("en-US", {
      year: "numeric", month: "long", day: "numeric", timeZone: "UTC",
    });
  } catch { return iso || ""; }
}
